import React from 'react';
import MyAccountCard from './MyAccountCard';

interface SkeletonLoaderProps {
    type?: 'text' | 'title' | 'table' | 'card' | 'panel';
    rows?: number;
    columns?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ 
    type = 'text', 
    rows = 3,
    columns = 3 
}) => {
    if (type === 'table') {
        return (
            <div className="skeleton-table">
                {/* Table header */}
                <div className="skeleton-row">
                    {Array.from({ length: columns }).map((_, i) => (
                        <div key={`header-${i}`} className="skeleton skeleton-cell" />
                    ))}
                </div>
                {/* Table rows */}
                {Array.from({ length: rows }).map((_, rowIndex) => (
                    <div key={`row-${rowIndex}`} className="skeleton-row">
                        {Array.from({ length: columns }).map((_, colIndex) => (
                            <div key={`cell-${rowIndex}-${colIndex}`} className="skeleton skeleton-cell" />
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    if (type === 'card') {
        return (
            <MyAccountCard
                variant="page"
                slug="skeleton"
                innerClassName="skeleton-card"
                wrapContent={false}
            >
                    <div className="skeleton skeleton-header" />
                    <div className="skeleton-content">
                        {Array.from({ length: rows }).map((_, i) => (
                            <div key={i} className="skeleton skeleton-line" />
                        ))}
                    </div>
            </MyAccountCard>
        );
    }

    if (type === 'panel') {
        return (
            <div className="portal-panel">
                <div className="portal-panel-container">
                    <div className="skeleton skeleton-text skeleton-title" />
                    <div className="skeleton-table">
                        <div className="skeleton-row">
                            {Array.from({ length: columns }).map((_, i) => (
                                <div key={`header-${i}`} className="skeleton skeleton-cell" />
                            ))}
                        </div>
                        {Array.from({ length: rows }).map((_, rowIndex) => (
                            <div key={`row-${rowIndex}`} className="skeleton-row">
                                {Array.from({ length: columns }).map((_, colIndex) => (
                                    <div key={`cell-${rowIndex}-${colIndex}`} className="skeleton skeleton-cell" />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (type === 'title') {
        return <div className="skeleton skeleton-text skeleton-title" />;
    }

    // Default: text lines
    return (
        <div>
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="skeleton skeleton-text skeleton-line" />
            ))}
        </div>
    );
};

export default SkeletonLoader;
